import apiClient from './client';
import type { ClassifierConfig } from './admin';

/**
 * Public (non-admin) classifiers API.
 *
 * The single endpoint exposed here returns the admin-curated classifier
 * registry stripped down to the subset the runtime UI needs: keys,
 * Romanian labels, cardinality and display flags. It's the data source
 * for `useClassifiersConfig()` and powers dynamic filters (MemberDetail)
 * and dynamic facet chip sections (DocumentView / member card preview).
 *
 * Endpoint is authenticated but NOT admin-gated — every signed-in user
 * needs it to render their own document UI.
 */
export const classifierApi = {
  config: async (): Promise<ClassifierConfig[]> => {
    const res = await apiClient.get('/api/classifiers/config');
    return res.data;
  },
};

export type { ClassifierConfig };
